<template>
  <div class="wrapper">
    <div>
      <Form :model="reSearch" inline :label-width="100">
        <FormItem label="名称">
          <Input v-model="reSearch.name" clearable />
        </FormItem>
        <FormItem label="级别">
          <Select
            v-model="reSearch.grade_id"
            filterable
            clearable
            placeholder="请选择级别"
            style="width: 180px"
          >
            <Option v-for="item in scopeGradeList" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="科目">
          <Select
            v-model="reSearch.subject_id"
            filterable
            clearable
            placeholder="请选择科目"
            style="width: 180px"
          >
            <Option v-for="item in scopeSubjectList" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <Button type="primary" @click="tabChange(labelMsgq)" icon="ios-search">搜索</Button>
      </Form>
    </div>
    <Tabs @on-click="tabChange" :value="labelMsgq">
      <TabPane label="当前考试" name="currents">
        <currentt :reSearch="reSearch" ref="currentt" />
      </TabPane>
      <TabPane label="历史考试" name="historys">
        <history :reSearch="reSearch" ref="history" />
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
  import currentt from "./currentt"
  import history from "./history"
  import scopeSearch from "../../mixins/scopeSearch"
  export default {
    mixins: [scopeSearch],
    data() {
      return {
        labelMsgq: "currents",
        reSearch: {
          name: "",
          grade_id: "",
          subject_id: "",
        },
      }
    },
    components: {
      currentt,
      history,
    },
    computed: {},
    mounted() {
      this.scopeSearchInit()
      this.$refs.currentt.getData(1)
    },
    methods: {
      tabChange(name) {
        this.labelMsgq = name
        if (name == "currents") {
          this.$refs.currentt.search()
          this.$refs.currentt.getData(1)
        } else if (name == "historys") {
          this.$refs.history.search()
          this.$refs.history.getData(1)
        }
      },
    },
  }
</script>
<style scoped lang="less">
  .wrapper {
    width: 100%;
    padding: 0 10px;
  }
</style>
